/**
 * A register as a CSV file, as the design's Export does: the header row, then one line per
 * row, quoted where a value needs it, with a byte-order mark so Excel reads the accents.
 */
export function downloadCsv(
    name: string,
    header: string[],
    rows: string[][],
    download: (name: string, csv: string) => void = saveFile,
) {
    const csv = [header, ...rows].map((cells) => cells.map(escape).join(',')).join('\r\n');
    download(name, csv);
}

/** "a-list-users-2026-09-03.csv": the register's slug and today's date. */
export function csvFileName(slug: string) {
    return `a-list-${slug}-${new Date().toISOString().slice(0, 10)}.csv`;
}

function escape(value: string): string {
    return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

function saveFile(name: string, csv: string) {
    const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
}
